import moment from 'moment';

const detalleDefault = {};

export const defaultSelectObjValue = {
  label: '',
  value: {}
};

/**
 * @params {array} files List of file items
 * @return FileList
 */
function FileListItems(files) {
  const b = new ClipboardEvent('').clipboardData || new DataTransfer();
  for (let i = 0, len = files.length; i < len; i += 1) b.items.add(files[i]);
  return b.files;
}

function dataURLtoFile(dataurl, filename) {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  // eslint-disable-next-line no-const-assign
  // eslint-disable-next-line no-plusplus
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

function getSamplePdf() {
  return new FileListItems([
    dataURLtoFile(
      'data:application/pdf;base64,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',
      'ejemplo.pdf'
    )
  ]);
}

const mainDefault = {
  // Empresa
  rucExportador: '',
  razonSocialExportador: '',
  ciudadExportador: '',
  direccionExpo: '',
  codigoPostal: '',
  personaContacto: '',
  telefono: '',
  emailExpo: '',
  // Importador
  importador: '',
  // Facturas
  facturas: '',
  // Mercaderias
  moneda: '',
  pesoEstimadoCarga: '',
  mercaderias: '',
  // Entrega
  persona: '',
  instruccion: ''
};

const ejemplo = {
  // Empresa
  rucExportador: '9999999999',
  razonSocialExportador: 'Exportador de Prueba',
  ciudadExportador: 'Asunción',
  direccionExpo: 'Mcal. López',
  codigoPostal: '1234',
  personaContacto: 'Representante de Prueba',
  telefono: '0981123456',
  emailExpo: 'prueba@vue.gov.py',
  // Importador
  importador: {
    nombre: 'Importador de prueba 3',
    id: 21,
    direccion: 'Dirección de prueba 3',
    nombrePais: 'País de prueba 3',
    ciudad: 'Ciudad de prueba 3',
    codigoPostal: '1234',
    email: 'prueba@vue.gov.py'
  },
  // Facturas
  facturas: [
    {
      id: 1,
      nroFactura: '001-001-1111111',
      timbrado: '1234567',
      montoFactura: '1000000',
      fechaFactura: moment('2020-11-06T11:02:31.552'),
      factura: getSamplePdf()
    },
    {
      id: 2,
      nroFactura: '001-001-2222222',
      timbrado: '1234567',
      montoFactura: '2000000',
      fechaFactura: moment('2020-11-06T11:02:31.552'),
      factura: getSamplePdf()
    }
  ],
  // Mercaderias
  moneda: {
    codigo: '029',
    descripcion: 'GUARANI'
  },
  pesoEstimadoCarga: '500',
  valorTotal: '3.000.000',
  cantidadTotal: '5',
  totalDolares: '400', // 7.500 Gs el USD
  mercaderias: [
    {
      id: '1',
      index: 1,
      partidaArancelaria: {
        id: 12,
        codigo: '0101.21.00.000',
        nombreResumido: 'Reproductores de raza pura'
      },
      descripcion: 'CABALLOS',
      cantidad: 2,
      valorVenta: '1000000',
      peso: '200',
      bulto: '1',
      unidad: {
        id: 1,
        descripcion: 'KILOGRAMO'
      },
      factura: {
        id: 1,
        label: '001-001-1111111 - 1.000.000',
        nroFactura: '001-001-1111111',
        timbrado: '1234567',
        montoFactura: '1000000',
        fechaFactura: moment('2020-11-06T11:02:31.552'),
        factura: getSamplePdf()
      }
    },
    {
      id: '2',
      index: 2,
      partidaArancelaria: {
        id: 13,
        codigo: '0101.29.00.000',
        nombreResumido: 'Los demas'
      },
      descripcion: 'VACAS',
      cantidad: 3,
      valorVenta: '2000000',
      peso: '300',
      bulto: '1',
      unidad: {
        id: 1,
        descripcion: 'KILOGRAMO'
      },
      factura: {
        id: 2,
        label: '001-001-2222222 - 2.000.000',
        nroFactura: '001-001-2222222',
        timbrado: '1234567',
        montoFactura: '2000000',
        fechaFactura: moment('2020-11-06T11:02:31.552'),
        factura: getSamplePdf()
      }
    }
  ],
  // Entrega
  persona: {
    nombre: 'Nombre de prueba 2',
    apellido: 'Apellido de prueba 2',
    info: 'Nombre de prueba 2 Apellido de prueba 2',
    id: 21
  },
  instruccion: {
    texto: 'Devolver',
    id: 'Devolver'
  }
};

const facturaDefault = {
  nroFactura: '',
  timbrado: '',
  fechaFactura: null,
  montoFactura: '',
  factura: ''
};

const mercaderiaDefault = {
  id: '',
  index: '',
  partidaArancelaria: '',
  descripcion: '',
  cantidad: '',
  valorVenta: '',
  peso: '',
  unidad: '',
  factura: '',
  bulto: ''
};

const getBase64 = file => {
  const getBasePromise = new Promise(resolve => {
    const reader = new FileReader();
    reader.addEventListener('load', () => resolve(reader.result));
    reader.readAsDataURL(file);
  });
  return getBasePromise;
};

const getFileValue = file => {
  if (file && file.length > 0) {
    return getBase64(file[0]);
  }
  return null;
};

const removeUnderscores = data => {
  if (data) {
    return data.replace(/_/g, '');
  }
  return '';
};

const getPhone = (prefijo, sufijo) => {
  if (prefijo && sufijo) {
    return `(${removeUnderscores(prefijo)})${removeUnderscores(sufijo)}`;
  }
  return '';
};

const getText = data => {
  if (data && data.texto) {
    return data.texto;
  }
  return null;
};

const getValue = data => {
  if (data && data.valor !== null) {
    return data.valor;
  }
  return null;
};

const getDateValue = fecha => {
  if (fecha) {
    return fecha.format('DD/MM/YYYY');
  }
  return null;
};

const getFileName = file => {
  if (file && file.length > 0) {
    return file[0].name;
  }
  return null;
};

// const getFileList = async data => {
//   const files = [];
//   files.push({
//     codigo: 'doc',
//     valor: await getFileValue(data.carne),
//     name: getFileName(data.carne)
//   });

//   return files.filter(({ valor }) => valor !== null);
// };

export {
  detalleDefault,
  ejemplo,
  facturaDefault,
  getDateValue,
  getFileName,
  getFileValue,
  getPhone,
  getText,
  getValue,
  mainDefault,
  mercaderiaDefault,
  removeUnderscores
};
